import React from 'react';
import { LumaSpin } from './ui/luma-spin';

const LumaLoader = () => {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white dark:bg-gray-900">
      <div className="flex flex-col items-center gap-6">
        {/* Logo or Brand */}
        <div className="text-center">
          <h1 className="text-2xl md:text-3xl font-bold text-primary font-poppins tracking-wide">
            Alpha Laser Technologies
          </h1>
        </div>
        
        {/* Luma Spin Loader */}
        <LumaSpin size={65} className="text-primary" />
        
        {/* Loading Text */}
        <p className="text-sm text-gray-500 dark:text-gray-400 animate-pulse">
          Loading...
        </p>
      </div>
    </div>
  );
};

export default LumaLoader;
